import { ADDONS_CATEGORIES, MEALS_CATEGORY } from 'src/constants/menu'

export const mapProductProps = product => ({
  ...product.properties,
  title: product.properties.name,
  premium_special: product.properties.isPremiumMeal,
  imageUrl: product.properties.image,
  qty: product.properties.cart.quantity,
  categoryId: getCategoryId(product.properties),
  meals: product.properties.items,
  premium_fee: product.properties.premiumFee,
  chef_firstname:
    product.properties.chef?.firstname || product.properties.cartChef?.name,
  chef_lastname: product.properties.chef?.lastname,
  chef_id: product.properties.chef?.id || product.properties.cartChef?.id,
  full_path_chef_image: product.properties.chef?.image,
  short_description: product.properties.description,
  specifications_detail: product.properties.specifications
})

const getCategoryId = properties => {
  if (properties.containsMeal) return MEALS_CATEGORY
  return properties.isExtra ? ADDONS_CATEGORIES[0] : MEALS_CATEGORY
}
